import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { getCroppedImg } from '../../utils';

const ModalImageCropper = ({ isOpen, image, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropChange = useCallback(newCrop => {
    setCrop(newCrop);
  }, []);

  const onZoomChange = useCallback(newZoom => {
    setZoom(newZoom);
  }, []);

  const onCropCompleteInternal = useCallback((croppedArea, newCroppedAreaPixels) => {
    setCroppedAreaPixels(newCroppedAreaPixels);
  }, []);

  const handleSave = async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);
      onCropComplete(croppedImage);
    } catch (e) {
      // ignore
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} size="lg">
      <ModalHeader toggle={onCancel}>Potong Gambar (Square 1:1)</ModalHeader>
      <ModalBody style={{ height: '400px', position: 'relative' }}>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={onCropChange}
          onCropComplete={onCropCompleteInternal}
          onZoomChange={onZoomChange}
        />
      </ModalBody>
      <ModalFooter>
        <div className="mr-auto d-flex align-items-center">
          <span className="mr-10">Zoom:</span>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={e => setZoom(e.target.value)}
            className="zoom-range"
          />
        </div>
        <Button color="secondary" onClick={onCancel}>
          Batal
        </Button>
        <Button color="primary" onClick={handleSave}>
          Simpan Crop
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalImageCropper;
